/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// Import zero symbols from zone.js. This causes the zone ambient type to be
// added to the type-checker, without emitting any runtime module load statement

import {} from 'zone.js';

// TODO(jteplitz602): Load WorkerGlobalScope from lib.webworker.d.ts file #3492
declare var WorkerGlobalScope: any /** TODO #9100 */;
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
declare var global: any /** TODO #9100 */;
const /** @type {?} */ __window = typeof window !== 'undefined' && window;
const /** @type {?} */ __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
const /** @type {?} */ __global = typeof global !== 'undefined' && global;
const /** @type {?} */ _global: {[name: string]: any} = __window || __global || __self;
export {_global as global};

// When Symbol.iterator doesn't exist, retrieves the key used in es6-shim
declare const Symbol: any;
let /** @type {?} */ _symbolIterator: any = null;
/**
 * @return {?}
 */
export function getSymbolIterator(): string|symbol {
  if (!_symbolIterator) {
    const /** @type {?} */ Symbol = _global['Symbol'];
    if (Symbol && Symbol.iterator) {
      _symbolIterator = Symbol.iterator;
    } else {
      // es6-shim specific logic
      const /** @type {?} */ keys = Object.getOwnPropertyNames(Map.prototype);
      for (let /** @type {?} */ i = 0; i < keys.length; ++i) {
        const /** @type {?} */ key = keys[i];
        if (key !== 'entries' && key !== 'size' &&
            ( /** @type {?} */((Map as any))).prototype[key] === Map.prototype['entries']) {
          _symbolIterator = key;
        }
      }
    }
  }
  return _symbolIterator;
}
/**
 * @param {?} fn
 * @return {?}
 */
export function scheduleMicroTask(fn: Function) {
  Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
export function looseIdentical(a: any, b: any): boolean {
  return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
/**
 * @param {?} token
 * @return {?}
 */
export function stringify(token: any): string {
  if (typeof token === 'string') {
    return token;
  }

  if (token == null) {
    return '' + token;
  }

  if (token.overriddenName) {
    return `${token.overriddenName}`;
  }

  if (token.name) {
    return `${token.name}`;
  }

  const /** @type {?} */ res = token.toString();

  if (res == null) {
    return '' + res;
  }

  const /** @type {?} */ newLineIndex = res.indexOf('\n');
  return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}



// WEBPACK FOOTER //
// ../../../../packages/core/src/util.ts